import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

export class HierarchyServiceHandler extends BaseService {
  isAuditButtonClicked: boolean;
  forAuditSearchList: boolean;

  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, '');
  }

  public init(modelNameList: string[]): Observable<Object> {
    return;
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean): Observable<Object> {
    return;
  }
  public process(id: any, modelNameList: string[]): Observable<Object> {
    return;
  }
  public find(executeSearch?: boolean, searchCriteriaData?: any): Observable<Object> {
    return;
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return null;
  }

  getSubOrdinateList(agentId) {
    let body = {
      agentId: agentId,
    };
    return this.httpPost('api/production/getSubOrdinateList', body);
  }
}
